import footerLogoSrc from '@/assets/images/layout/gainhow_footer.png';

import store01Qr from '@/assets/images/layout/store_manager_01_qr.png';
import store01Manager from '@/assets/images/layout/store_manager_01.png';
import store02Qr from '@/assets/images/layout/store_manager_02_qr.png';
import store02Manager from '@/assets/images/layout/store_manager_02.png';
import store03Qr from '@/assets/images/layout/store_manager_03_qr.png';
import store03Manager from '@/assets/images/layout/store_manager_03.png';
import store04Qr from '@/assets/images/layout/store_manager_04_qr.png';
import store04Manager from '@/assets/images/layout/store_manager_04.png';
import store05Qr from '@/assets/images/layout/store_manager_05_qr.png';
import store05Manager from '@/assets/images/layout/store_manager_05.png';
import store06Qr from '@/assets/images/layout/store_manager_06_qr.png';
import store06Manager from '@/assets/images/layout/store_manager_06.png';
import store07Qr from '@/assets/images/layout/store_manager_07_qr.png';
import store07Manager from '@/assets/images/layout/store_manager_07.png';
import store08Qr from '@/assets/images/layout/store_manager_08_qr.png';
import store08Manager from '@/assets/images/layout/store_manager_08.png';
import store09Qr from '@/assets/images/layout/store_manager_09_qr.png';
import store09Manager from '@/assets/images/layout/store_manager_09.png';

export { footerLogoSrc };

export interface LayoutFooterLink {
    label: string;
    url: string;
    isExternal?: boolean;
}

export interface LayoutFooterLinkGroup {
    key: string;
    title: string;
    links: LayoutFooterLink[];
}

export interface LayoutFooterStore {
    name: string;
    url: string;
    phone: string;
    qrCodeUrl: string;
    qrImageSrc: string;
    managerImageSrc: string;
    managerName: string;
    managerTitle: string;
    managerPhone: string;
    fullPhone: string;
    address: string;
    hours: string;
    services: string;
}

export interface LayoutFooterSocialLink {
    iconName: string;
    label: string;
    url: string;
}

export const LAYOUT_FOOTER_LINK_GROUPS: LayoutFooterLinkGroup[] = [
    {
        key: 'about-us',
        title: '關於我們',
        links: [
            { label: '關於健豪', url: '/Home/Equipments' },
            { label: '關於網站', url: '/Home/AboutUs' },
            { label: '專車路線', url: '/Home/shippingCar' },
            { label: '媒體報導參訪', url: '/Home/MediaArea' },
            {
                label: '生產製程影音導覽',
                url: '/Home/MediaArea/Manufacture',
            },
        ],
    },
    {
        key: 'popular-links',
        title: '熱門連結',
        links: [
            { label: '聯絡我們', url: '/Home/ContactUs' },
            {
                label: '健豪盃',
                url: 'https://www.gding.com.tw/ghawd/',
                isExternal: true,
            },
            { label: '作品分享', url: '/Portfolio/Shared' },
            {
                label: '價格表樣品',
                url: '/ProductCategory/ProductsClassification/ReadyProduct',
            },
            { label: '商品材質總覽', url: '/ProductCategory/Materials' },
            {
                label: '獲獎桌月曆',
                url: 'https://www.gding.com.tw/calendar/2027/calendar-a.htm',
                isExternal: true,
            },
            {
                label: '現成紅包袋',
                url: 'https://gainhow.tw/Images/CustomProduct/ProductCategory/RedEnvelopes_Patterns.pdf',
                isExternal: true,
            },
            { label: '教育專案', url: '/Education' },
        ],
    },
    {
        key: 'help-center',
        title: '幫助專區',
        links: [
            { label: '常見問題', url: '/Home/faq?b=a03&c=faqcolor_1' },
            { label: '線上編輯器教學', url: '/Home/faq?b=a04' },
            { label: '傳檔發印相關', url: '/Home/faq?b=a03&c=faqcolor_4' },
            { label: '紙張尺寸圖表', url: '/Home/faq?b=a03&c=faqcolor_9' },
            { label: '訂購流程', url: '/Account/NoviceOrderProcess' },
        ],
    },
    {
        key: 'services',
        title: '系列服務',
        links: [
            { label: 'APP 下載', url: '/Home/App' },
            {
                label: '包裝網',
                url: 'https://box.gainhow.tw/',
                isExternal: true,
            },
            {
                label: '文創網',
                url: 'https://mask.gainhow.tw/',
                isExternal: true,
            },
            { label: '特約企業專區', url: '/Enterprise' },
            { label: '企業用戶專區', url: '/EnterprisePortal/Product' },
            { label: '電子型錄', url: '/Catalog/Index' },
        ],
    },
];

export const LAYOUT_FOOTER_STORES: LayoutFooterStore[] = [
    {
        name: '台中總公司',
        url: '/Home/store?id=05',
        phone: '(04) 2375-1958',
        qrCodeUrl: 'https://lin.ee/lpvra4Z',
        qrImageSrc: store01Qr,
        managerImageSrc: store01Manager,
        managerName: '林佩諭',
        managerTitle: '副理',
        managerPhone: '(04) 2375-1958 #1',
        fullPhone: '04-2375-1958、04-3600-8366',
        address: '403 台中市西區忠明南路230號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '中和旗艦店',
        url: '/Home/store?id=03',
        phone: '(02) 2242-1958',
        qrCodeUrl: 'https://lin.ee/eySO90Y',
        qrImageSrc: store02Qr,
        managerImageSrc: store02Manager,
        managerName: '林儀琳',
        managerTitle: '店長',
        managerPhone: '(02) 2242-1958 #1',
        fullPhone: '02-2242-1958、02-6637-3380',
        address: '235 新北市中和區中山路二段346號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '台中精科廠',
        url: '/Home/store?id=06',
        phone: '(04) 2359-1958',
        qrCodeUrl: 'https://lin.ee/gaqALEh',
        qrImageSrc: store03Qr,
        managerImageSrc: store03Manager,
        managerName: '馬瑞家',
        managerTitle: '廠長',
        managerPhone: '(04) 2359-1958 #1',
        fullPhone: '04-2359-1958、04-3609-1958',
        address: '408 台中市南屯區精科一路9號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services: '商品取貨',
    },
    {
        name: '社子營業處',
        url: '/Home/store?id=02',
        phone: '(02) 2815-1958',
        qrCodeUrl: 'https://lin.ee/OGe22Ln',
        qrImageSrc: store04Qr,
        managerImageSrc: store04Manager,
        managerName: '吳逸芬',
        managerTitle: '副店長',
        managerPhone: '(02) 2815-1958 #1',
        fullPhone: '02-2815-1958、02-6617-6880',
        address: '111 台北市士林區延平北路五段274號',
        hours: '星期一~五 10:00~20:00\n星期六不營業',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '八德營業處',
        url: '/Home/store?id=01',
        phone: '(02) 2760-3586',
        qrCodeUrl: 'https://lin.ee/didzBfE',
        qrImageSrc: store05Qr,
        managerImageSrc: store05Manager,
        managerName: '林依潔',
        managerTitle: '店長',
        managerPhone: '(02) 2760-3586 #1',
        fullPhone: '02-2760-3586、02-6617-6868',
        address: '105 台北市松山區八德路四段78號',
        hours: '星期一~五 09:00~21:00\n星期六不營業',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '台南營業處',
        url: '/Home/store?id=07',
        phone: '(06) 251-1958',
        qrCodeUrl: 'https://lin.ee/Pu0FoI9',
        qrImageSrc: store06Qr,
        managerImageSrc: store06Manager,
        managerName: '林建生',
        managerTitle: '店長',
        managerPhone: '(06) 251-1958 #1',
        fullPhone: '06-251-1958、06-602-7258',
        address: '710 台南市永康區小北路26號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '新莊營業處',
        url: '/Home/store?id=14',
        phone: '(02) 6626-1958',
        qrCodeUrl: 'https://lin.ee/QGUk5Yw',
        qrImageSrc: store07Qr,
        managerImageSrc: store07Manager,
        managerName: '呂學懿',
        managerTitle: '店長',
        managerPhone: '(02) 6626-1958 #1',
        fullPhone: '02-6626-1958',
        address: '242 新北市新莊區化成路11巷16號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '新竹旗艦店',
        url: '/Home/store?id=13',
        phone: '(03) 611-1958',
        qrCodeUrl: 'https://lin.ee/mGjxDhf',
        qrImageSrc: store08Qr,
        managerImageSrc: store08Manager,
        managerName: '鍾治邦',
        managerTitle: '店長',
        managerPhone: '(03) 611-1958 #1',
        fullPhone: '03-611-1958',
        address: '302 新竹縣竹北市縣政二路41號',
        hours: '星期一~五 10:00~20:00\n星期六不營業',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
    {
        name: '高雄營業處',
        url: '/Home/store?id=08',
        phone: '(07) 349-7958',
        qrCodeUrl: 'https://lin.ee/8tXowiG',
        qrImageSrc: store09Qr,
        managerImageSrc: store09Manager,
        managerName: '周明芳',
        managerTitle: '店長',
        managerPhone: '(07) 349-7958 #1',
        fullPhone: '07-349-7958、07-963-1959',
        address: '813 高雄市左營區民族一路663號',
        hours: '星期一~五 09:00~21:00\n星期六 09:00~18:00',
        services:
            '客服諮詢、繳費儲值、客服發稿、商品取貨、價格表販售、免費紙樣索取',
    },
];

export const LAYOUT_FOOTER_SOCIAL_LINKS: LayoutFooterSocialLink[] = [
    {
        iconName: 'instagram-regular',
        label: 'Instagram',
        url: 'https://www.instagram.com/gainhow1997/',
    },
    {
        iconName: 'facebook-regular',
        label: 'Facebook',
        url: 'https://www.facebook.com/gainhow.tw/',
    },
    {
        iconName: 'youtube-regular',
        label: 'YouTube',
        url: 'https://www.youtube.com/@gainhow1997',
    },
    {
        iconName: 'line-regular',
        label: 'LINE',
        url: 'https://line.me/R/ti/p/%40836gecce',
    },
];

export const LAYOUT_FOOTER_TERM_LINKS: LayoutFooterLink[] = [
    { label: '委託製作契約', url: '/Home/faq?b=a01&d=d03' },
    { label: '服務使用條款', url: '/Home/faq?b=a01&d=d01' },
    { label: '隱私權條款', url: '/Home/faq?b=a01&d=d02' },
];

export const LAYOUT_FOOTER_COPYRIGHT = '©2024 GainHow. All rights reserved';
